module.exports = __webpack_public_path__ + "static/media/0255_Small.da97867c.jpg";